/**
 * @Des 新增/编辑 账户 弹出层
 * @Auth
 * @Date 2021/6/19
 */

/* HTML */
<template>
    <div v-if="dialogForm.dialogFormVisible">
    	<el-dialog :title="dialogForm.title"
	               :visible.sync="dialogForm.dialogFormVisible"
	               :close-on-click-modal="false"
	               :modal-append-to-body="false"
	               custom-class="form-dialog"
	               v-dialogDrag
	               class="dialog_title"
	               @close="handleDialogClose"
	    >
			<el-button-group style="position: absolute;right: 20px;z-index: 99;">
				<el-button type="primary" size="mini" :class="{'on': dialogForm.slotType == 'day'}" @click="() => {searchUserHeart('day');}">今日</el-button>
				<el-button type="primary" size="mini" :class="{'on': dialogForm.slotType == 'week'}" @click="() => {searchUserHeart('week');}">近一周</el-button>
				<el-button type="primary" size="mini" :class="{'on': dialogForm.slotType == 'month'}" @click="() => {searchUserHeart('month');}">近一月</el-button>
			</el-button-group>
            <ve-line :data="chartData" :settings="chartSettings" :extend="extend" :title="chartTitle" height="100%"></ve-line>

	    </el-dialog>
    </div>
</template>

/* JS */
<script>
    import VeLine from 'v-charts/lib/line'
    // 交互 接口
    import ApiUser from '@/request/api-user'

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/19
         */
        name: 'UserHealthyDialog',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/19
         */
        props:{
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/19
         */
        components: {
            VeLine
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/19
         */
        data() {
            return{
                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogForm: {
                    title: "",
                    submitButton: '',
                    optionType: '',
                    dialogFormVisible: false,
                    slotType: 'day',
                },
                chartTitle: ['心率变化'],
                chartData: {},
                columns: ['时间', '心率值'],
                chartSettings: {
                    xAxisName: ['时间'],
                    yAxisName: ['心率值'],
                },
                extend: {
                	/*title:{
                		show: true,
                		text:'心率变化',
                		//subtext:'各城市对应的拓展',
                		textAlign:'center',
                	},*/
                	// 标题
                	title: {
                		show: true,
                		text: '心率变化',
                		left: '50%',
                		textStyle: {
                			color: '#909090',
                			fontSize: 18,
                			fontFamily: 'PingFangSC-Regular',
                		}
                	},
                    xAxis: {
                        nameTextStyle: {
                            fontWeight: 600,
                            fontSize: 16
                        }
                    },
                    yAxis: {
                        nameTextStyle: {
                            fontWeight: 600,
                            fontSize: 16
                        }
                    },
					backgroundColor: '#FBFBFB',
                	// 图标顶部的标题及按钮
                	legend:{
                		show:false,
                	},
                },
                userId: ''
            }
        },
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/19
         */
        methods:{
            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 2021/6/19
             */
            openDialog(title, userId){
                // console.log(data);
                this.dialogForm.dialogFormVisible = true;
				this.dialogForm.title = title;
                this.userId = userId;
                this.dialogForm.slotType = 'day';

                // 重置表单
                this.reset();

                // 查找心率
                this.findUserHeart();

            },

            /**
             * 查找用户心率
             * */
            findUserHeart(startDate, endDate){
                this.$request.postJsonRequest(ApiUser.findUserHearts,{
                    userId: this.userId,
                    // projectId: this.$store.state.currentProjectId,
                    startDate: startDate==undefined?'':startDate,
                    endDate: endDate==undefined?'':endDate,
                    interpolation: false,
                    interpolationTime: 60000
                }).then(result => {
                    this.chartData = {};
                    let format = 'HH:mm';
                    if(this.dialogForm.slotType == 'week'){
                        format = 'MM/DD HH:mm'
                    }else if(this.dialogForm.slotType == 'month'){
                        format = 'MM/DD HH:mm'
                    }
                    let rows = [];
                    if(result.code == 0){
                        result.data.forEach((row, index) => {
                            rows.push({
                                "时间": row.t?this.$moment(row.t).format(format):'',
                                "心率值": row.v
                            })
                        })
                    }
                    if(rows.length == 0){
                        this.$message({
                            message: '心率未上报，请检查设备运行状态...',
                            type: 'warning',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }
                    this.chartData = {
                        columns: this.columns,
                        rows: rows,
                    };
                });
            },
            /**
             * @Des 查询心率信息
             * @Auth
             * @Date 2021/6/19
             */
            searchUserHeart(slotType) {
            	this.dialogForm.slotType = slotType;

            	let time = new Date().getTime();
            	let today = this.$moment(time).format('YYYY-MM-DD');
            	let endDate = [today, '23:59:59'].join(' ');
            	let startDate = '';
            	switch(this.dialogForm.slotType) {
            		case 'day':
            			startDate = [today, '00:00:00'].join(' ');
            			break;
            		case 'week':
            			startDate = [this.$moment(time - 7*24*60*60*1000).format('YYYY-MM-DD'), '00:00:00'].join(' ');
            			break;
            		case 'month':
            			startDate = [this.$moment(time - 30*24*60*60*1000).format('YYYY-MM-DD'), '00:00:00'].join(' ');
            			break;
            		default:
            			startDate = '';
            	}
            	// 查找用户心率
            	this.findUserHeart(startDate, endDate);
            },


            /**
             * @Des 提交账户信息
             * @Auth
             * @Date 2021/6/19
             */
            submitForm(){
            },

            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 2021/6/19
	         */
	        handleDialogClose(){
	        },

            /**
	         * @Des 重置方法
	         * @Auth Zhangbin
	         * @Date 17:28 2021/4/30
	         */
	        reset(){
	        },


        },// methods
    }
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog{
		width: 90%;
		height: 80%;
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/User/UserHealthyDialog.vue